module.exports = __webpack_public_path__ + "img/ingHelper.d348b93f.png";